/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_P1_DInputs */

const en_mk_sec_pg_p1_d = /** @type {(inputs: Mk_Sec_Pg_P1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every read filters by workspace first. A request from outside the membership is not answered “forbidden” but “not found” — so even the existence of the data does not leak.`)
};

const id_mk_sec_pg_p1_d = /** @type {(inputs: Mk_Sec_Pg_P1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap pembacaan data menyaring workspace lebih dulu. Permintaan dari luar keanggotaan tidak dijawab "dilarang" melainkan "tidak ada" — supaya keberadaan data pun tidak bocor.`)
};

/**
* | output |
* | --- |
* | "Every read filters by workspace first. A request from outside the membership is not answered “forbidden” but “not found” — so even the existence of the data ..." |
*
* @param {Mk_Sec_Pg_P1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_p1_d = /** @type {((inputs?: Mk_Sec_Pg_P1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_P1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_p1_d(inputs)
	return en_mk_sec_pg_p1_d(inputs)
});